/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 09:53:13
 * @lastTime: 2023-11-10 16:51:03
 * @LastEditors: caiqin.xie
 * @message: 更多新闻
 */
import React, { useState } from 'react'
import styles from './index.module.scss'
import classNames from 'classnames'
import LazyMedia from '@/components/LazyMedia'
import { INews } from '@/common/types'

interface IProps {
  className?: string;
  titleClassName?: string; // 标题样式
  moreNewsList: INews[]; // 更多新闻
  ctry: string;
  words: Record<string, string>;
}

const MoreNews = (props: IProps) => {
  const { ctry, moreNewsList, words, className, titleClassName } = props

  // 新页签打开新闻链接
  const handleNewsClick = (news: INews) => {
    window.open(`/${ctry}/newsroom/${news.seoUrl}`, '_blank')
  }

  return (
    <>
      {moreNewsList && moreNewsList.length > 0 && (
        <section className={className}>
          <h2 className={titleClassName}>
            {words?.newsroom_more_news}
            {/* More News */}
          </h2>
          <div className={styles['more-news-list']}>
            {moreNewsList.map((item, index) => (
              <div
                className={classNames(styles['more-item'], {
                  [styles['more-item-border-none']]: moreNewsList.length % 2 == 0
                })}
                key={item.id}
                onClick={() => handleNewsClick(item)}
              >
                <div className={styles['more-item-pic']}>
                  <LazyMedia type="image" LazyClassName="full-wh" src={item?.cover} alt={item?.coverAlt} />
                </div>
                <div className={styles['more-item-content']}>
                  <h3 className={styles['more-item-title']}>{item?.title}</h3>
                  <p className={styles['more-item-date']}>{item?.publishDate}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  )
}
export default MoreNews
